module.exports = __webpack_public_path__ + "img/damnn_group_header.2f3d79c8.png";